import React from "react";
import { Card, Space, Select, Divider, Button, InputNumber, Tooltip, Switch } from "antd";

const FilterPanel = ({
  statusFilter,
  tipoIstanzaFilter,
  useStatusFilter,
  useTipoIstanzaFilter,
  useProximityFilter,
  proximityRange,
  userLocation,
  customLocation,
  useCustomLocation,
  isSelectingLocation,
  loadingLocation,
  handleStatusChange,
  handleTipoIstanzaChange,
  handleProximityRangeChange,
  setUseProximityFilter,
  useMyLocation,
  startCustomLocationSelection,
  filtering,
  showCompetitors,
  setShowCompetitors,
  showPartners,
  setShowPartners
}) => {
  return (
    <Card title="Filtri" size="small" style={{ marginBottom: '16px' }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <div style={{ marginBottom: '8px' }}>Stato:</div>
          <Select 
            value={useStatusFilter ? statusFilter : "tutti"} 
            onChange={handleStatusChange}
            style={{ width: '100%' }}
            disabled={filtering || isSelectingLocation}
          >
            <Select.Option value="tutti">Tutti</Select.Option>
            <Select.Option value="attiva">Attiva</Select.Option>
            <Select.Option value="disattiva">Disattiva</Select.Option>
          </Select>
        </div>
        
        <div>
          <div style={{ marginBottom: '8px' }}>Tipo Istanza:</div>
          <Select 
            value={useTipoIstanzaFilter ? tipoIstanzaFilter : "tutti"} 
            onChange={handleTipoIstanzaChange}
            style={{ width: '100%' }}
            disabled={filtering || isSelectingLocation}
          >
            <Select.Option value="tutti">Tutti</Select.Option>
            <Select.Option value="production">Production</Select.Option>
            <Select.Option value="demo">Demo</Select.Option>
            <Select.Option value="free">Free</Select.Option>
          </Select>
        </div>

        <Divider style={{ margin: '12px 0' }} />
        
        <div>
          <div style={{ marginBottom: '8px' }}>
            <span style={{ fontWeight: 'bold' }}>Filtra per posizione:</span>
          </div>
          
          <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
            <Tooltip title="Usa la tua posizione attuale">
              <Button 
                type={useProximityFilter && !useCustomLocation ? "primary" : "default"}
                onClick={useMyLocation}
                loading={loadingLocation && !useCustomLocation}
                icon={<span role="img" aria-label="la tua posizione">📍</span>}
                style={{ flex: 1 }}
                disabled={filtering || isSelectingLocation}
              >
                La mia posizione
              </Button>
            </Tooltip>
            
            <Tooltip title="Seleziona un punto sulla mappa">
              <Button 
                type={useCustomLocation ? "primary" : "default"}
                onClick={startCustomLocationSelection}
                loading={isSelectingLocation}
                icon={<span role="img" aria-label="punto sulla mappa">🗺️</span>}
                style={{ flex: 1 }}
                disabled={filtering || isSelectingLocation}
              >
                Punto sulla mappa
              </Button>
            </Tooltip>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <InputNumber
              min={1}
              max={500}
              step={10}
              value={proximityRange}
              onChange={handleProximityRangeChange}
              style={{ width: '100%' }}
              disabled={!useProximityFilter || filtering || isSelectingLocation}
              formatter={(value) => `${value}`}
              parser={(value) => value.replace(/[^\d]/g, '')}
            />
            <span>km</span>
          </div>
          
          {useProximityFilter && (
            <Button 
              type="default"
              danger
              size="small"
              onClick={() => setUseProximityFilter(false)}
              style={{ width: '100%' }}
              disabled={filtering || isSelectingLocation}
            >
              Disattiva filtro per posizione
            </Button>
          )}
          
          {userLocation && !useCustomLocation && (
            <div style={{ marginTop: '8px', fontSize: '12px', color: '#888' }}>
              La tua posizione: {userLocation.latitude.toFixed(4)}, {userLocation.longitude.toFixed(4)}
            </div>
          )}
          
          {customLocation && useCustomLocation && (
            <div style={{ marginTop: '8px', fontSize: '12px', color: '#888' }}>
              Punto selezionato: {customLocation.lat.toFixed(4)}, {customLocation.lng.toFixed(4)}
            </div>
          )}
          
          {isSelectingLocation && (
            <div style={{ marginTop: '8px', fontSize: '12px', color: '#f50' }}>
              Clicca sulla mappa per selezionare un punto
            </div>
          )}
        </div>

        <Divider style={{ margin: '12px 0' }} />
        
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 'bold' }}>Mostra Competitor:</span>
          <Switch 
            checked={showCompetitors}
            onChange={setShowCompetitors}
            disabled={filtering || isSelectingLocation}
            checkedChildren="Sì"
            unCheckedChildren="No"
          />
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 'bold' }}>Mostra Partner:</span>
          <Switch 
            checked={showPartners}
            onChange={setShowPartners}
            disabled={filtering || isSelectingLocation}
            checkedChildren="Sì"
            unCheckedChildren="No"
          />
        </div>
      </Space>
    </Card>
  );
};

export default FilterPanel; 